import React, { useEffect, useMemo, useState } from "react";

import { getTpmSummaryReport } from "../../../../services/features/reports.service";
import {
  KpiRow,
  KpiTile,
  ReportGrid,
  ChartCard,
  EmptyNote,
  ReportBar,
  ReportDonut,
  FLAG_COLORS,
  OK_COLOR,
  BRAND,
  num,
  pct,
  barData,
  barOptions,
  donutData,
  donutOptions,
  allZero,
} from "./reportShared";

// Report 4 — Red Flags & Accountability. Issues raised during monitoring and
// how many have been resolved.
const RedFlagsReport = ({ onReady, onLoadingChange }) => {
  const projectId = localStorage.getItem("currentProjectID");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    getTpmSummaryReport(
      { projectId },
      (res) => {
        setData(res?.data || null);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [projectId]);

  const rf = data?.redFlagsProgress || {};
  const notAddressed = num(rf.assigned);
  const inProgress = num(rf.inprogress);
  const onHold = num(rf.onhold);
  const resolved = num(rf.resolved);
  const archived = num(rf.archived);

  const open = notAddressed + inProgress + onHold;
  const total = open + resolved + archived;
  const resolutionRate = pct(resolved, open + resolved); // of live (non-archived) flags

  const kpis = useMemo(
    () => [
      { label: "Total flags", value: total, color: BRAND },
      { label: "Open", value: open, color: FLAG_COLORS.notAddressed },
      { label: "Resolved", value: resolved, color: OK_COLOR },
      { label: "Resolution rate", value: resolutionRate, suffix: "%", color: OK_COLOR },
      { label: "Archived", value: archived, color: FLAG_COLORS.archived },
    ],
    [total, open, resolved, resolutionRate, archived]
  );

  useEffect(() => {
    onLoadingChange?.(loading);
  }, [loading, onLoadingChange]);
  useEffect(() => {
    if (!loading) onReady?.(kpis);
  }, [loading, kpis, onReady]);

  if (loading) return null;

  const statusRows = [
    { label: "Not addressed", value: notAddressed, color: FLAG_COLORS.notAddressed },
    { label: "In progress", value: inProgress, color: FLAG_COLORS.inProgress },
    { label: "On hold", value: onHold, color: FLAG_COLORS.onHold },
    { label: "Resolved", value: resolved, color: FLAG_COLORS.resolved },
    { label: "Archived", value: archived, color: FLAG_COLORS.archived },
  ];

  return (
    <>
      <KpiRow>
        {kpis.map((k) => (
          <KpiTile key={k.label} {...k} />
        ))}
      </KpiRow>

      <ReportGrid>
        <ChartCard title="Flags by status" hint="Distribution">
          {allZero(statusRows) ? (
            <EmptyNote />
          ) : (
            <ReportDonut data={donutData(statusRows)} options={donutOptions} />
          )}
        </ChartCard>

        <ChartCard title="Flags by status (count)">
          {allZero(statusRows) ? (
            <EmptyNote />
          ) : (
            <ReportBar data={barData(statusRows, [])} options={barOptions(true)} />
          )}
        </ChartCard>
      </ReportGrid>
    </>
  );
};

export default RedFlagsReport;
